exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#pufferfish .pufferfish-404{position:relative;top:0;bottom:0;padding-top:20vh;text-align:center;color:rgba(48,48,48,0.5);font-size:28px;font-weight:bold}\n", ""]);
